import { render, staticRenderFns } from "./BindsListItemFakeButton.vue?vue&type=template&id=04127553&"
import script from "./BindsListItemFakeButton.vue?vue&type=script&lang=js&"
export * from "./BindsListItemFakeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports